import React, { useContext, useState, Fragment } from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import TextareaAutosize from 'react-textarea-autosize'
import { store, actions } from '../../stores/multipost'
import { accountTypes } from '../Share/SocialAccountsSelector'
import { AlertCircle } from 'react-feather'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import ProviderMessage from './ProviderMessage'

export default function Messages() {
  const { selectedAccounts, messages, selectedFiles, dispatch } = useContext(store)
  const providerMessagesPresent = Object.keys(messages).filter(key => key !== 'default' && messages[key].value.length > 0).length > 0

  const [unifiedMessage, setUnifiedMessage] = useState(!providerMessagesPresent)
  const maxLength = Math.min(...selectedAccounts.map(account => accountTypes[account].max))

  const overLength = messages.default.overLength
  const length = messages.default.value.length
  const displayLength = overLength ? maxLength - length : length
  const hasStories = selectedFiles.some(f => f.assets.some(a => a.enabledActions.some(a => selectedAccounts.includes(a.provider) && a.story)))
  const hasInstagramAssets = selectedFiles.some(f => f.assets.some(a => a.enabledActions.some(a => a.provider == 'instagram' && !a.story)))

  let warnings = []

  if(length > 0 && hasStories) {
    warnings.push('Message will not be posted to Facebook or Instagram Stories')
  }

  if(selectedAccounts.includes('instagram') && !hasInstagramAssets && ((unifiedMessage && messages.default.value.length > 0) || messages.instagram.value.length > 0)) {
    warnings.push('Message will not be posted to Instagram without an image or video')
  }

  const onChange = (e) => {
    dispatch({
      type: actions.SET_MESSAGES,
      messages: {
        ...messages,
        default: {
          value: e.target.value,
          overLength: e.target.value.length > maxLength,
        },
      },
    })
  }

  return (
    <>
    <Card className="rounded-2 mb-4">
      <CardHeader className={`rounded-top-2 d-flex justify-content-between align-items-center ${!unifiedMessage && 'border-bottom-0'}`}>
      <UncontrolledDropdown>
      <DropdownToggle caret color="link" className="p-0">{unifiedMessage ? 'Message for all posts' : 'Message per account'}</DropdownToggle>
      <DropdownMenu className="p-0">
        <DropdownItem onClick={() => setUnifiedMessage(true)}>Message for all posts</DropdownItem>
        <DropdownItem onClick={() => setUnifiedMessage(false)}>Message per account</DropdownItem>
      </DropdownMenu>
      </UncontrolledDropdown>
        { unifiedMessage && selectedAccounts.length > 0 && (
          <div className={overLength ? 'text-danger' : 'text-muted'}>
            {displayLength}/{maxLength}
          </div>
        )}
      </CardHeader>
      <CardBody className="p-0">
        { unifiedMessage ? (
          <TextareaAutosize
            className="form-control border-0 shadow-none p-3"
            id="messages-default"
            name="team_post[messages][default]"
            minRows={7}
            placeholder="This message is optional…"
            onChange={onChange}
            value={messages.default.value}
            disabled={selectedAccounts.length === 0}
          />
        ) : (
          selectedAccounts.map(provider => (
            <ProviderMessage key={provider} provider={provider} />
          ))
        )}
      </CardBody>
    </Card>
    { warnings.length > 0 && (
      warnings.map((warning, index) => (
        <div key={`warning-${index}`} className="rounded-2 p-2 bold mb-4 d-flex align-items-center" style={{ backgroundColor: '#E4E9EF' }}>
          <AlertCircle size="18" color="#37444B" />
          <span className="ms-2" style={{ color: '#37444B' }}>{warning}</span>
        </div>
      ))
    )}
    </>
  )
}